import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '#utilities/js/ea/globals.js'
import { hotkey } from './hotkey.js'

const handler = object(null, {
  task (
    element,
    event
  ) {
    preventDefault(event)
    const { dataset } = element
    const { url = '', target = '' } = dataset

    if (url === '') {
      return
    }

    globals.ea_link(url, target, null)
  }
})

export default (
  element
) => {
  hotkey(element, handler)
}
